import { useContext } from 'react';
import { PresentationSheetContext } from 'contexts/presentationSheetContext/PresentationContext';

export const usePresentationSheetContext = () => {
	return useContext(PresentationSheetContext);
};
